import { render, staticRenderFns } from "./UrunIslemleri.vue?vue&type=template&id=0b59ab9a&scoped=true&"
import script from "./UrunIslemleri.vue?vue&type=script&lang=js&"
export * from "./UrunIslemleri.vue?vue&type=script&lang=js&"
import style0 from "./UrunIslemleri.vue?vue&type=style&index=0&id=0b59ab9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b59ab9a",
  null
  
)

export default component.exports